// (function () {
//     'use strict';

//     angular.module("imApp").factory("csvExportArgService", ['$ihttp', function ($ihttp) {
//         let service = {
//             getSetting: function (parms) {
//                 return $ihttp.post({
//                     method: 1527,
//                     parameters: parms || {}
//                 });
//             },
//             executeCsv: function (setting) {
//                 return $ihttp.post({
//                     method: 1528,
//                     parameters: setting
//                 });
//             }
//         };

//         return service;
//     }]);
// })();
